"use client";

import React from "react";
import styles from "./GlobalLoader.module.scss";
import LottieLoader from "@components/atoms/LottieLoader";

interface GlobalLoaderProps {
  isLoading?: boolean;
  className?: string;
  size?: "small" | "medium" | "large";
  variant?: "spinner" | "dots" | "pulse" | "lottie";
  overlay?: boolean;
  text?: string;
  lottieWidth?: number;
  lottieHeight?: number;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  isLoading = true,
  className = "",
  size = "small",
  variant = "spinner",
  overlay = false,
  text = "Loading...",
  lottieWidth,
  lottieHeight,
}) => {
  if (!isLoading) return null;

  const getLottieSize = () => {
    switch (size) {
      case "small":
        return { width: lottieWidth || 80, height: lottieHeight || 80 };
      case "large":
        return { width: lottieWidth || 120, height: lottieHeight || 120 };
      default:
        return { width: lottieWidth || 120, height: lottieHeight || 120 };
    }
  };

  const loaderContent = (
    <div className={`${styles.loaderContainer} ${className}`}>
      {variant === "spinner" && (
        <div className={`${styles.spinner} ${styles[size]}`}>
          <div className={styles.spinnerInner}></div>
        </div>
      )}
      
      {variant === "dots" && (
        <div className={`${styles.dots} ${styles[size]}`}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
      )}
      
      {variant === "pulse" && (
        <div className={`${styles.pulse} ${styles[size]}`}></div>
      )}
      
      {variant === "lottie" && (
        <div className={styles.lottieContainer}>
          <LottieLoader
            width={getLottieSize().width}
            height={getLottieSize().height}
            loop={true}
            autoplay={true}
            className={styles.lottieLoader}
          />
        </div>
      )}
      
      {text && <div className={styles.loaderText}>{text}</div>}
    </div>
  );

  if (overlay) {
    return (
      <div className={styles.overlay}>
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default GlobalLoader; 